// extracted by mini-css-extract-plugin
export default {"main":"Search_main__-eaAs","tags_box":"Search_tags_box__NB358","search_not":"Search_search_not__Rz1Hy","list":"Search_list__V3pxG"};